import { render } from "./P2.vue?vue&type=template&id=fc4d7580&scoped=true"
import script from "./P2.vue?vue&type=script&lang=js"
export * from "./P2.vue?vue&type=script&lang=js"

import "./P2.vue?vue&type=style&index=0&id=fc4d7580&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc4d7580"

export default script